import { Directive, ElementRef, HostListener, AfterViewInit } from '@angular/core';
import { AutoGrowDirective } from './auto-grow.directive';

@Directive({
  selector: '[autoResize]',
  standalone: false,
})
export class AutoResizeDirective extends AutoGrowDirective implements AfterViewInit {

  // @override
  protected adjust(): void {
      let nativeElement = this.element.nativeElement;
      nativeElement.style.transition = 'height 0s';
      nativeElement.style.overflow = 'hidden';
      nativeElement.style.height = 'auto';
      nativeElement.style['max-height'] = (nativeElement.scrollHeight - 16) + "px";
      nativeElement.style['min-height'] = "45px";
      nativeElement.style.height = (nativeElement.scrollHeight - 16) + "px";
      nativeElement.style['padding-bottom'] = '2px';
  }

  @HostListener('input')
  onInput(): void {
    this.adjust();
  }
}
